module.exports = __webpack_public_path__ + "static/img/hlogo01.cd87af6c.png";